import { Eye, Target, Gem } from "lucide-react";

const cards = [
  {
    icon: Eye,
    title: "Vision",
    body: "Redefine event experiences across India.",
  },
  {
    icon: Target,
    title: "Mission",
    body: "Deliver unforgettable experiences.",
  },
  {
    icon: Gem,
    title: "Core Values",
    body: "Creativity, Innovation, Excellence, Passion.",
  },
];

export default function VisionMission() {
  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="section"
      style={{
        background:
          "linear-gradient(180deg, transparent, rgba(212,175,55,0.03) 50%, transparent)",
      }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center fade-up max-w-2xl mx-auto">
          <div className="eyebrow justify-center mb-4">The Compass</div>
          <h2 className="section-title">
            Vision · <span className="gold-text-gradient">Mission</span> · Values
          </h2>
          <p className="mt-4 text-neutral-400">
            What drives every guest list, stage design and playlist we approve.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {cards.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              data-testid={`vision-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
              className="glass rounded-3xl p-8 card-hover fade-up"
            >
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center border border-[var(--ee-border)] bg-black/30">
                <Icon size={22} className="text-[var(--ee-gold)]" />
              </div>
              <h3 className="mt-6 font-display text-3xl">{title}</h3>
              <p className="mt-3 text-sm text-neutral-400 leading-relaxed">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
